import $ from 'jquery'
import { closeModal } from '@/function/function.js';
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import { openSelectOptions, selectOption, cr_state } from '@/select-box.js';

Vue.use(VueHtml2pdf)


export default {
    name: 'caisse-versement',
    components: {

    },
    props: [],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            curr_state: cr_state,
            dest_selected: '',
            destination_id: 0,
            fondIsDisabled: Boolean,

            total_recettes: 0,
            total_depenses: 0,
            idUser: 1,
            date_versement: '',

            loading: false,
            argent: [10000, 5000, 2000, 1000, 500],
            argent_piece: [500, 250, 100, 50, 25, 10, 1],

            solde_reel: 0, //  Solde réel (Solde compté physiquement)
            solde_theorique: 0, //  Solde théorique (Solde récupéré à partir de la somme des opérations ayant eu lieu)
            erreur_caisse: 0, //  Écart de caisse
            fond_caisse: 0, //  Fonds de caisse
            solde_cloture: 0, //  Solde de cloture
            montant_a_verser: 0, //  Montant à verser
            commentaire: '',
            total_versements_faits: 0,
            total_versements_recus: 0,

            total_piece: 0,
            total_billet: 0,

            billets: [{
                "billet_nb": '',
                "billet_total": '',
            }],

            pieces: [{
                "piece_nb": '',
                "piece_total": '',
            }],
            billet_argents: ['10 000', '5 000', '2 000', '1 000', '500'],

            piece_argents: ['500', '250', '100', '50', '25', '10', '1'],

            solde_is_loading: true,
            save_loading: false,
            is_closing_cash_register: false,
            recap_check_loading: true
        }
    },
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        /**
         * Solde disponible (Solde théorique)
         * @returns 
         */
        // total_solde() {
        //     return parseInt(this.total_recettes) + parseInt(this.total_versements_recus) - parseInt(this.total_depenses) - parseInt(this.total_versements_faits);
        // },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },

        activeRole(){
            return this.$store.getters['activeRole'];
        },

        solde_disponible() {
            return this.$store.getters["solde_disponible"];
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },
    },
    mounted() {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.fond_caisse = 0
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
                this.fond_caisse = 0
                this.fondIsDisabled = true; //  Rendre le checkbox disable afin de ne pas inclure le fonds de caisse
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
            // Destination
            if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.dest_selected = 'Caisse principale'
                this.destination_id = 1
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.dest_selected = 'Trésorerie'
                this.destination_id = 6
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.dest_selected = 'Banque'
                this.destination_id = 2
            }
        } else {
            this.$router.push({ "path": "/login" })
        }

        this.getSoldeDisponible()

        for (let i = 1; i <= 5; i++) {
            this.billets.push({ billet_nb: '', billet_total: '' });
        }

        for (let i = 1; i <= 7; i++) {
            this.pieces.push({ piece_nb: '', piece_total: '' });
        }

        $(document).bind('click', function(e) {
            let $clicked = $(e.target);
            this.curr_state = 0;
            if (!$clicked.parents().hasClass("select-box")) {
                $('.select-opts').removeClass('animate-fadeInRight');
                $('.select-opts').addClass('animate-fadeOutRight');
                $('.select-opts').fadeOut();
            }
        });

        this.date_versement = new Date()

        this.is_closing_cash_register = this.$store.getters['is_closing_cash']

        this.getDiversInfo()
    },
    methods: {
        getDiversInfo() {
            this.recap_check_loading = true
            this.$store.dispatch('getConfigInfoClinique', 'divers_info').then(() => {
                this.recap_check_loading = false
            })
        },

        getSoldeDisponible() {
            const data = {
                compte_id: this.compte_id,
                date: this.getDates().today_date,
                user_id: this.user_id
            }
            this.$store.dispatch("getSoldeDisponible", data).then(() => {
                this.solde_is_loading = false
            })
        },

        /**
         * Date
         * @returns 
         */
        getDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() + 1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth()+1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        /**
         * 
         * @param {*} selector 
         * @param {*} index 
         */
        async calculArgent(selector, index) {
            this.clearError()
            this.solde_reel = 0;

            if (selector == 'billet') { //  >>> Controle des billets
                this.total_billet = 0;
                this.billets[index].billet_total = this.billets[index].billet_nb * this.argent[index];


                for (let i = 0; i < 5; i++) {
                    this.billets[i].billet_total = (this.billets[i].billet_total == '') ? 0 : this.billets[i].billet_total;
                    this.total_billet += this.billets[i].billet_total;
                }

            } else { //  >>> Controle des pièces
                this.total_piece = 0;

                this.pieces[index].piece_total = this.pieces[index].piece_nb * this.argent_piece[index];


                for (let i = 0; i < 7; i++) {
                    this.pieces[i].piece_total = (this.pieces[i].piece_total == '') ? 0 : this.pieces[i].piece_total;
                    this.total_piece += this.pieces[i].piece_total;
                }
            }
            // >>>  Calcul montant des billets & pièces
            this.solde_reel = this.total_billet + this.total_piece;
        },

        /**
         * Formatter le montant
         * @param {*} currency 
         */
        formatCurrency(currency) {
            return new Number(currency).toLocaleString("fr-FR");
        },

        /**
         * Recapitulatif du contrôle des espèces
         */
        recapControle() {
            let err = 0
            if (this.solde_reel == 0) {
                $('.err-msg-0').fadeIn()
                err++
            }

            if (err == 0) {
                // Calcul de l'erreur de caisse
                this.erreur_caisse = this.solde_reel - this.solde_disponible;

                $('.controle-espece').removeClass('animate-fadeInLeft');
                $('.controle-espece').addClass('animate-fadeOutLeft');
                $('.controle-espece').fadeOut();

                $('.recap-controle').fadeIn();
                $('.recap-controle').removeClass('animate-fadeOutLeft');
                $('.recap-controle').addClass('animate-fadeInRight');

                // // Montant à verser
                // this.montant_a_verser = this.solde_reel - this.fond_caisse;

                // // Solde de cloture
                // this.solde_cloture = this.fond_caisse;

                // Montant à verser
                if (this.solde_reel < this.fond_caisse) {
                    this.montant_a_verser = this.solde_reel;

                    // Solde de cloture
                    // this.solde_cloture = 0;
                    this.fondIsDisabled = true;
                } else {
                    this.montant_a_verser = this.solde_reel - this.fond_caisse;

                    // Solde de cloture
                    // this.solde_cloture = this.fond_caisse;
                    this.fondIsDisabled = false;
                }

                if (this.solde_disponible > this.montant_a_verser) {
                    this.solde_cloture = this.solde_disponible - this.montant_a_verser
                } else {
                    this.solde_cloture = 0;
                }
            }
        },

        /**
         * Inclure le fonds de caisse au versement
         */
        inclureFondCaisse() {
            let fond_caisse_is_included = document.getElementById('inc-fond');

            let sc = (fond_caisse_is_included.checked) ? 0 : this.fond_caisse
            // this.solde_cloture = sc;
            $('#sc').val(this.formatCurrency(sc));

            let mav = (fond_caisse_is_included.checked) ? (this.solde_reel) : (this.solde_reel - this.fond_caisse)
            this.montant_a_verser = mav
            $('#mnt-a-verser').val(this.formatCurrency(mav))
        },

        /**
         * Deduire le montant à verser si le solde de cloture change
         */
        onMontantAverser() {
            // let mav = $('#mav').val()
            // if (mav >= 0 && mav <= this.solde_reel) {
            //     this.solde_cloture = ((this.solde_reel - this.fond_caisse) - mav) + this.fond_caisse;
            // }
        },

        /**
         * Recompter les espèces 
         */
        recompterEspece() {
            $('.recap-controle').removeClass('animate-fadeInRight');
            $('.recap-controle').addClass('animate-fadeOutLeft');
            $('.recap-controle').fadeOut();

            $('.controle-espece').fadeIn();
            $('.controle-espece').removeClass('animate-fadeOutLeft');
            $('.controle-espece').addClass('animate-fadeInLeft');

            // >>>>     REMISE DES CONTROLE A 0    <<<<
        },

        async effectuerVersement() {
            this.save_loading = true;
            this.btn_disable = true
            let controle_argents = []

            // RECAP CONTROLE DES BILLETS 
            for (let bx = 0; bx < this.billet_argents.length; bx++) {
                let nb = (this.billets[bx].billet_nb != '') ? this.billets[bx].billet_nb : 0
                let b = this.billet_argents[bx]
                let contorle = 'b' + '-' + nb + '-' + b

                controle_argents.push(
                    contorle
                )
            }
            // RECAP CONTROLE DES PIECES
            for (let bx = 0; bx < this.piece_argents.length; bx++) {
                let nb = (this.pieces[bx].piece_nb != '') ? this.pieces[bx].piece_nb : 0
                let b = this.piece_argents[bx]
                let contorle = 'p' + '-' + nb + '-' + b
                controle_argents.push(
                    contorle
                )
            }

            this.info_caissier = {
                nom_caissier: this.userCredentials.user.name,
                titre: this.userCredentials.user.titre
            }

            const data = {
                data_type: "versement",
                compte_id: this.compte_id,
                user_id: this.user_id,
                solde_au_versement: this.solde_disponible,
                montant_verse: this.montant_a_verser,
                solde_cloture: parseInt(this.solde_cloture),
                destination: this.destination_id,
                commentaire: this.commentaire,
                ecart_caisse: this.erreur_caisse,
                controle_caisse: controle_argents,
                is_closing_cash_register: this.is_closing_cash_register,
                info_caissier: {
                    nom_caissier: this.userCredentials.user.name,
                    titre: this.userCredentials.user.titre
                }
            }

            this.$store.dispatch('doCaisseVersement', data).then((response) => {
                if (response.success) {
                    this.save_loading = false;
                    this.btn_disable = false
                    $('.modal').modal('hide')
                    this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
                } else {
                    if (response.code === 501) {
                        this.save_loading = false;
                        this.warningToast("Une erreur s'est produite ! Merci de réessayer plustard")
                    }
                }
            }).catch(() => {
                this.warningToast("Une erreur s'est produite ! Merci de réessayer plustard")
                this.save_loading = false;
            })
        },

        /**
         * Continue et affiche le rapport de cloture de caisse
         */
        continuer() {
            let comment = $('#vrs-comment').val();
            let err = 0
            // CHAMP COMMENTAIRE OBLIGATOIRE  -  commenter si pas obligatoire
            if (this.erreur_caisse != 0 && (this.divers_info.show_recap_operation == 'Oui')) {
                if (comment == '') {
                    $('.err-msg-1').fadeIn(1000)
                    err++
                }
            }
            if(this.montant_a_verser == 0 || this.montant_a_verser == '') {
                $('.err-msg-2').fadeIn(1000)
                err++
            } else if(this.montant_a_verser > this.solde_reel) {
                $('.err-msg-3').fadeIn(1000)
                err++
            }

            if (err == 0) {
                this.commentaire = comment
                $('#rapport-cloture').modal('show')
            }
        },

        clearError() {
            for(let i = 0; i <= 3; i++) {
                $('.err-msg-'+i).fadeOut(500)
            }
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        /**
         * Show select options in dropdown
         * @param {int} j_state 
         * @param {string} selector 
         */
        async openSelectOption(j_state, selector) {

            this.curr_state = openSelectOptions.openSelectOption(j_state, selector)
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value
         * @param {string} selected_id 
         * @param {string} selector 
         * @param {string} model_selector 
         */
        async selectOption(selected_value, selected_id, selector, model_selector) {
            this.curr_state = selectOption.chooseOption(selected_id, selector)

            switch (model_selector) {
                case 'dest':
                    this.dest_selected = selected_value;
                    break;
            }

            // Recupere la destination choisie
            this.destination_id = selected_id;
        },

        /**
         * Imprimer le rapport de versement
         */
        printRapport() {
            let comment = ''
            $('#r-comment').html(comment)
            this.$refs.html2Pdf.generatePdf()
        },
    }
}